import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from '../Axiosinstance';
import Header from './Header';
import { Modal } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, Box } from '@mui/material';


function NewFacilitator({ onFormSubmit }) {
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [facilitator, setFacilitator] = useState({
    salutation: '',
    nric: '',
    email: '',
    phone: '',
    // educational_level: '',
    qualification: '',
    domain: '',
    gender: '',
    password: '',
    name: '',
    // usertype: '',
  });
  const [error, setError] = useState('');

  const [errors, setErrors] = useState({
    salutation: '',
    nric: '',
    email: '',
    phone: '',
    // educational_level: '',
    qualification: '',
    // domain: '',
    gender: '',
    password: '',
    name: '',
    // usertype: '',
  });


  const {
    salutation,
    nric,
    email,
    phone,
    // educational_level,
    qualification,
    // domain,
    gender,
    password,
    name,
    // usertype
  } = facilitator;


  const onInputChange = (e) => {
    const { name, value } = e.target;

    // Update the facilitator state correctly
    setFacilitator((prev) => ({
        ...prev,
        [name]: value // Use "name" instead of "e.target.name"
    })); // <-- Closing parenthesis was missing here

    // Clear the error message for the specific field
    setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: ''
    }));
};

  const checkFacilitatorExists = async (name, email) => {
    try {
      const response = await axios.get('facilitators', { params: { name, email } });
      const emailExists = response.data.some(facilitator => facilitator.email === email);
      const nricExists = response.data.some(facilitator => facilitator.nric === nric);
      return { emailExists, nricExists };
    } catch (error) {
      console.error("Error checking facilitator:", error);
      return { emailExists: false, nricExists: false };
    }
  };

  const createFacilitator = async (facilitatorData) => {
    try {
      const response = await axios.post('facilitator', facilitatorData);
      return response.data.id;
    } catch (error) {
      console.error('Error creating facilitator:', error);
      setError('Error creating facilitator');
      return null;
    }
  };

  const createUser = async (userData) => {
    try {
      await axios.post('auth/create-user', userData);
      return true;
    } catch (error) {
      console.error('Error adding user:', error);
      setError('Error adding user');
      return false;
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // Validate Form Fields
    const validationErrors = {};
    if (!salutation) validationErrors.salutation = 'Salutation is required';
    if (!name) validationErrors.name = 'Name is required';
    if (!email) validationErrors.email = 'Email is required';
    if (!phone) validationErrors.phone = 'Phone is required';
    if (!qualification) validationErrors.qualification = 'Qualification is required';
    if (!gender) validationErrors.gender = 'Gender is required';
    if (!password) validationErrors.password = 'Password is required';

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Check if Facilitator Already Exists
    const { emailExists, nricExists } = await checkFacilitatorExists(name, email, nric);

    if (emailExists) {
      setError("Email ID already exists.");
      return;
    }

    if (nricExists) {
      setError("NRIC already exists.");
      return;
    }



    // Create Facilitator
    const newFacilitatorId = await createFacilitator(facilitator);
    if (!newFacilitatorId) return;

    // Create User
    const userData = {
      email,
      name,
      username: name,
      password,
      usertype: 2,
      sfid: newFacilitatorId,
    };

    const userCreated = await createUser(userData);
    if (!userCreated) return;

    toast.success('Facilitator added successfully!', { position: 'top-right', autoClose: 3000 });
    navigate('/facilitor');
    onFormSubmit();
  };


  const [isFormDirty, setIsFormDirty] = useState(false);

  const handleInputChange = () => {
    if (!isFormDirty) {
      setIsFormDirty(true);
    }
  };


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isFormDirty) {
        event.preventDefault();
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave this page?';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);


    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isFormDirty]);




  const handleCancel = () => {


    {
      onFormSubmit();
    }
  };



  const handleConfirmSave = () => {
    setShowConfirmationModal(false);
    onFormSubmit();
  };

  const handleCancelSave = () => {
    setShowConfirmationModal(false);
  };



  return (
    <div className="containerw mx-auto" style={{
      maxWidth: '1000px',
      background: '#ffffff',
      padding: '20px',
      boxShadow: '0px 0px 2px 0px #000000',
      borderRadius: '10px',
    }}>
      <h4> New Facilitator (Newton International College)</h4>
      <hr style={{ marginTop: '1%' }} />
      {error && <div className="text-danger">{error}</div>}
      <form onSubmit={onSubmit} onChange={handleInputChange} style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ marginRight: '20px', flex: 1 }}>
          <div className="form-group">
            <label>Salutation</label>
            <select
              className="form-control"
              name="salutation"
              value={facilitator.salutation}
              onChange={onInputChange}
              style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', height: '45px', borderRadius: '6px', border: '1px solid #ced4da' }} required
            >
              <option value="">Select Salutation</option>
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
              <option value="Ms.">Ms.</option>
            </select>
            {errors.salutation && (
              <div className="text-danger">{errors.salutation}</div>
            )}
          </div>


          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={facilitator.name}
              required

              onChange={(e) => {
                const inputValue = e.target.value;
                const onlyLetters = /^[A-Za-z\s]+$/; // Regular expression for letters and spaces


                if ((inputValue.length <= 30 && onlyLetters.test(inputValue)) || inputValue === "") {
                  onInputChange(e);
                }
              }}
              title={facilitator.name.length >= 30 ? "Maximum 30 characters only" : ""}
              style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }} />
            {(errors.name || !facilitator.name) && <div className="text-danger">{errors.name}</div>}
          </div>


          <div className="form-group">
    <label htmlFor="nric">NRIC/FIN No*</label>
    <input
        type="text"
        className="form-control"
        name="nric"
        value={facilitator.nric || ""} // Ensure controlled input
        onChange={(e) => {
            let inputValue = e.target.value.toUpperCase().trim(); // Convert to uppercase & trim spaces
            
            // NRIC format: Starts with S, T, F, G, M + 7 digits + an alphabet
            const nricRegex = /^[STFGM]\d{7}[A-Z]?$/i; 

            // Restrict length to exactly 9 characters
            if (inputValue.length > 9) return;

            // Update state to ensure React re-renders the input field
            onInputChange({ target: { name: "nric", value: inputValue } });
        }}
        maxLength={9} // Prevents typing more than 9 characters
        placeholder="e.g., S1234567A"
        style={{ 
            maxWidth: '100%', 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            width: '100%', 
            height: '42px', 
            borderRadius: '6px', 
            border: '1px solid #ced4da' 
        }}
    />
    {errors.nric && <div className="text-danger">{errors.nric}</div>}
</div>




          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={facilitator.email}
              onChange={onInputChange}
              style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }} required
            />
            {(errors.email || !facilitator.email) && <div className="text-danger">{errors.email}</div>}
          </div>




          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="number"
              id="phone"
              className="form-control"
              name="phone"
              value={facilitator.phone}
              onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}


              onChange={(e) => {
                const inputText = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                const formattedText = inputText.substring(0, 10);

                // Update the facilitator state
                setFacilitator({ ...facilitator, phone: formattedText });
              }}
              required
            />
            {(errors.phone || !facilitator.phone) && <div className="text-danger">{errors.phone}</div>}
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <div className="form-group">
            <label htmlFor="qualification">Qualification</label>
            <input
              type="text"
              className="form-control"
              name="qualification"
              value={facilitator.qualification}
              onChange={(e) => {
                const inputValue = e.target.value;
                // const onlyLetters = /^[A-Za-z\s]+$/; // Regular expression for letters and spaces
                // If the input matches the regular expression or is empty, update the state
                // if ((inputValue.length <= 40 && onlyLetters.test(inputValue)) || inputValue === "") {
                setFacilitator((prevFacilitator) => ({
                  ...prevFacilitator,
                  qualification: inputValue,
                }));
                // }
              }}
              required
              title={
                facilitator.qualification.length >= 40 ? "20 characters maximum" : "Only letters and spaces allowed"
              }
              style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }} />


            {(errors.qualification || !facilitator.qualification) && <div className="text-danger">{errors.qualification}</div>}
          </div>


          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              value={facilitator.password}
              style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
              onChange={onInputChange}
              autoComplete="new-password"
            />
            {(errors.password || !facilitator.password) && <div className="text-danger">{errors.password || ""}</div>}
          </div>

          <div className="form-group">
            <label>Gender</label>
            <div>
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="gender"
                  value="Male"
                  checked={facilitator.gender === 'Male'}
                  onChange={onInputChange}
                  required
                />
                <label className="form-check-label">Male</label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="gender"
                  value="Female"
                  checked={facilitator.gender === 'Female'}
                  onChange={onInputChange}
                  required
                />
                <label className="form-check-label">Female</label>
              </div>
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  name="gender"
                  value="Other"
                  checked={facilitator.gender === 'Other'}
                  onChange={onInputChange}
                  required
                />
                <label className="form-check-label">Other</label>
              </div>
            </div>
            {(errors.gender || !facilitator.gender) && <div className="text-danger">{errors.gender}</div>}
          </div>
          <>
          <Box
  sx={{
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'end',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: 2,
    mt: 7.5, // 60px
    mx: { xs: 0, sm: 'auto' },
  }}
>
  <Button
    onClick={onSubmit}
    sx={{
      backgroundColor: 'green',
      fontSize: '13px',
      color: 'white',
      px: 2,
      py: 1,
      borderRadius: '7px',
      '&:hover': {
        backgroundColor: 'green',
      },
    }}
    // startIcon={<FaPlus />}
  >
    Add Facilitator
  </Button>

  <ToastContainer style={{ marginTop: '2%' }} />

  <Button
    onClick={handleCancel}
    sx={{
      backgroundColor: 'red',
      fontSize: '13px',
      color: 'white',
      px: 3,
      py: 1,
      borderRadius: '7px',
      '&:hover': {
        backgroundColor: 'red',
      },
    }}
  >
    Cancel
  </Button>
</Box>
          </>
        </div>
      </form>
    </div>
  );
}

const Batchess = ({ onFormSubmit }) => {
  return (
    <div>

      <NewFacilitator onFormSubmit={onFormSubmit} />
    </div>
  );
};


export default Batchess;

